export class AccountImportExampleModel {
	AccountNumber: string;
	AccountDescription = 'Maxiumum of 50 characters';
	AccountType = 'Must be one of the following: \n\nAsset\nLiability\nExpense\nRevenue\nNet\nReserve';
	StartDate = "Must be in the format 'MM/DD/YYYY'\n\nMust be before the End Date";
	EndDate = "Must be in the format 'MM/DD/YYYY'\n\nMust be after the Start Date";
	BeginningBalance = 'Must be a number or empty\n\nIf empty, the Beginning Balance will be set to 0';

	constructor(AccountNumber: string) {
		this.AccountNumber = 'There should be NO spaces in column headers of file \n\n';
		this.AccountNumber += AccountNumber;
	}
}
